import { Stack, Typography } from '@mui/material';

import { SUBMIT_PAGE_BOX_SX } from './styles';
import { QuestionnaireSectionLabel } from '../../../common/components';
import { FORTA_BLUE } from '../../../../../utils/colors';

export default function SubmitForm() {
  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Submit
      </QuestionnaireSectionLabel>
      <Stack sx={SUBMIT_PAGE_BOX_SX}>
        <Typography sx={{ fontWeight: 'bold', maxWidth: '700px' }}>
          Please note that once you conclude this Client Onboarding, you will not be able to make
          any further changes. Be sure to review all information carefully before submitting.
        </Typography>
        <Typography sx={{ maxWidth: '700px', mt: 4 }}>
          We appreciate your effort in providing the details needed to help us deliver quality ABA
          support for your child. Our team will be in touch soon with the next steps.
        </Typography>
      </Stack>
    </>
  );
}
